import styled from 'styled-components';
export const LoaderContainer = styled.div`
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ChartContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 6px;
  padding: 16px;
  gap: 32px;
  flex-grow: 1;
`;
